module.exports = __webpack_public_path__ + "Editar.svg?b83b1007050b91614e2421898cf31ded";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Editar.svg
// module id = 780
// module chunks = 0